/* Neubau D · Produktseite unten: Passt dazu, Das könnte dir auch gefallen, Ganzes Sortiment (Hülle: d-product-empfehlungen).
   Lädt erst, wenn die Hülle in die Nähe des Bildschirms kommt, damit über dem Fold nichts langsamer wird.
   Alle Kacheln kommen fertig gerendert aus dem Abschnitt d-empfehlungen-teil (Section Rendering API).
   Reihenfolge: Passt dazu (complementary, leer → Theme-Regel über die Produkt-URL) und Gefallen (related) zuerst,
   dann das Sortiment seitenweise; was schon zu sehen ist, wird übersprungen. Keine Bewegung, kein Gleiten.
   „In die Tüte“ in den Kacheln macht d-kd.js über [data-kd-add]. */
(() => {
  const PART = 'd-empfehlungen-teil';

  const fetchPart = async (url) => {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(String(res.status));
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    return doc.querySelector('[data-kpe-part]');
  };
  const withParams = (base, params) => {
    const u = new URL(base, location.origin);
    Object.entries(params).forEach(([k, v]) => u.searchParams.set(k, v));
    return u.pathname + u.search;
  };

  const init = (root) => {
    if (root.dataset.kpeReady) return;
    root.dataset.kpeReady = '1';
    const d = root.dataset;
    const txt = root.querySelector('[data-kpe-text]')?.dataset || {};
    const seen = new Set([String(d.pid)]);
    const limit = Number(d.limit) || 8;

    /* Kacheln aus einem Teil übernehmen, Doppelte und das Produkt selbst auslassen. Gibt die Zahl neuer Kacheln zurück. */
    const take = (part, box, max = Infinity) => {
      if (!part) return 0;
      let n = 0;
      part.querySelectorAll('[data-kpe-id]').forEach((tile) => {
        const id = tile.getAttribute('data-kpe-id');
        if (n >= max || seen.has(id)) return;
        seen.add(id);
        box.appendChild(document.importNode(tile, true));
        n += 1;
      });
      return n;
    };
    const block = (name) => root.querySelector(`[data-kpe-block="${name}"]`);
    const show = (name, part) => {
      const b = block(name);
      if (take(part, b.querySelector('[data-kpe-tiles]'), limit) > 0) b.hidden = false;
    };

    const recs = (intent) => fetchPart(withParams(d.recs, { product_id: d.pid, limit: limit + 2, intent, section_id: PART }));

    const loadTop = async () => {
      let fits = null;
      try {
        fits = await recs('complementary');
      } catch (e) { fits = null; }
      if (!fits || !fits.querySelector('[data-kpe-id]')) {
        try { fits = await fetchPart(withParams(d.self, { section_id: PART })); } catch (e) { fits = null; }
      }
      show('complementary', fits);
      let rel = null;
      try { rel = await recs('related'); } catch (e) { rel = null; }
      show('related', rel);
    };

    /* Ganzes Sortiment: seitenweise, bis Shopify keine Seite mehr hat. */
    const all = block('all');
    const grid = all.querySelector('[data-kpe-tiles]');
    const more = all.querySelector('[data-kpe-more]');
    const moreLabel = all.querySelector('[data-kpe-more-label]');
    const end = all.querySelector('[data-kpe-end]');
    const status = all.querySelector('[data-kpe-status]');
    const sentinel = all.querySelector('[data-kpe-sentinel]');
    let page = 0;
    let pages = 1;
    let busy = false;
    let io = null;
    let failed = false; /* nach einem Fehler lädt nur noch der Knopf, damit nichts im Kreis abruft */

    const finish = () => {
      more.hidden = true;
      end.hidden = grid.children.length === 0;
      if (io) io.disconnect();
      removeEventListener('scroll', onScroll);
    };
    const loadPage = async () => {
      if (busy || page >= pages) return;
      busy = true;
      more.disabled = true;
      moreLabel.textContent = txt.loading || '…';
      let added = 0;
      try {
        /* Seiten, auf denen alles schon oben steht, zählen nicht: weiter, bis etwas Neues kommt oder Schluss ist. */
        while (page < pages && added === 0) {
          const part = await fetchPart(withParams(d.all, { section_id: PART, page: page + 1 }));
          if (!part) throw new Error('leer');
          page = Number(part.dataset.kpePage) || page + 1;
          pages = Number(part.dataset.kpePages) || page;
          added += take(part, grid);
        }
        if (added > 0 && txt.loaded) status.textContent = txt.loaded.replace('#', String(added));
        moreLabel.textContent = txt.more || '';
        more.disabled = false;
        if (page >= pages) finish(); else more.hidden = false;
      } catch (e) {
        failed = true;
        moreLabel.textContent = txt.error || txt.more || '';
        more.disabled = false;
        more.hidden = false;
      }
      busy = false;
      /* Steht das Ende noch im Blick (große Bildschirme), gleich die nächste Seite holen. */
      if (!failed && io && near()) loadPage();
    };
    more.addEventListener('click', () => { failed = false; loadPage(); });

    /* Beim Scrollen prüfen, ob das Rasterende höchstens 600 px unter dem Bildschirm oder schon darüber liegt.
       Der Beobachter allein verpasst einen Sprung ans Seitenende (Taste Ende, schnelles Wischen) über die Markierung hinweg. */
    let ticking = false;
    const near = () => page < pages && sentinel.getBoundingClientRect().top < innerHeight + 600;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; if (!failed && near()) loadPage(); });
    };
    const startAll = () => {
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver((entries) => {
          if (!failed && entries.some((en) => en.isIntersecting)) loadPage();
        }, { rootMargin: '0px 0px 600px 0px' });
        io.observe(sentinel);
        addEventListener('scroll', onScroll, { passive: true });
        if (near()) loadPage();
      } else {
        more.hidden = false;
      }
    };

    loadTop().finally(startAll);
  };

  const boot = () => {
    document.querySelectorAll('[data-kpe]').forEach((root) => {
      if (!('IntersectionObserver' in window)) { init(root); return; }
      const io = new IntersectionObserver((entries, obs) => {
        if (entries.some((en) => en.isIntersecting)) { obs.disconnect(); init(root); }
      }, { rootMargin: '0px 0px 800px 0px' });
      io.observe(root);
    });
  };
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot, { once: true });
})();
